import DealStatus from '@/creditflowresearch/ui/common/components/TableCells/DealStatus';
import type { IDealStatus } from '@/creditflowresearch/domain/vo/IDeal';
import { useTableDictionaries } from '@/creditflowresearch/application/TableDictionaries';

interface IStatusCellProps {
  statusId: number,
}

const StatusCell = ({ statusId }: IStatusCellProps) => {
  const { dealStatuses } = useTableDictionaries();
  const status = dealStatuses?.getById(statusId);

  if (!status) {
    return (<>-</>);
  }

  return (
    <DealStatus status={ status as IDealStatus } />
  );
};

export default StatusCell;
